import * as z from 'zod';
import { ACCOUNTING_HEADING_TYPE } from 'src/features/accountingHeaders/utils/types';

export type AccountingHeadingFormSchemaValues = z.infer<typeof accountingHeadingFormSchema>;
export const accountingHeadingFormSchema = z
    .object({
            name: z.string().nonempty(),
            account: z.string().nonempty(),
            type: z.enum(ACCOUNTING_HEADING_TYPE),
            partide: z.string().optional().nullable(),
            billing_entity: z.string().nonempty(),
            parent: z.string().optional().nullable(),
    });